import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { useCookie } from '../context/CookieConsentContext';

export default function CookiesPolicyPage() {
  const { openModal } = useCookie();

  return (
    <div className="max-w-4xl mx-auto p-8 text-gray-800 leading-7">
      <h1 className="text-3xl font-bold mb-6">Política de cookies</h1>

      <p className="mb-4">
        Esta política explica el uso de cookies y tecnologías similares en este sitio web, en cumplimiento de la Ley 34/2002, de servicios de la sociedad de la información y comercio electrónico, y de la normativa de protección de datos aplicable.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">¿Qué utiliza actualmente este sitio?</h2>
      <p className="mb-4">
        En el estado actual del sitio, no se activan cookies analíticas, publicitarias ni de personalización no esenciales. Únicamente se emplean elementos técnicos necesarios para el funcionamiento básico y para recordar si el aviso informativo ya ha sido mostrado.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cookies o almacenamiento técnico</h2>
      <p className="mb-4">
        Estos elementos son necesarios para el funcionamiento básico del sitio, la navegación o la gestión de preferencias técnicas. Su uso no requiere consentimiento previo cuando son estrictamente necesarios.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cookies opcionales en el futuro</h2>
      <p className="mb-4">
        Si en el futuro se incorporan cookies de análisis, medición, personalización o publicidad comportamental, se informará de forma específica y se solicitará consentimiento previo antes de activarlas.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cómo gestionar la información almacenada</h2>
      <p className="mb-4">
        Puedes volver a abrir el aviso informativo desde los{' '}
        <button
          onClick={openModal}
          className="text-blue-600 underline hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-300"
        >
          ajustes de privacidad
        </button>
        . También puedes eliminar los datos almacenados desde la configuración de tu navegador.
      </p>

      <p className="mb-4">
        Para más información sobre el tratamiento de datos personales, consulta la{' '}
        <Link to={ROUTES.privacyPolicy} className="text-blue-600 underline hover:text-blue-800">
          Política de privacidad
        </Link>.
      </p>
    </div>
  );
}
